import React from 'react';
import '../styles/SkeletonCard.css'; // ไฟล์ CSS สำหรับ Skeleton

const SkeletonCard = () => {
    return (
        <div className="skeleton-card">
             <div className="loading-bar-container">
                <div className="loading-bar"></div>
            </div>
            <div className="skeleton-header"></div>
            <div className="skeleton-content"></div>
        </div>
    );
};

export default SkeletonCard;
